"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLwtStore = void 0;
const use_context_with_error_handler_1 = __importDefault(require("../@common/hooks/use-context-with-error-handler"));
const LwtStoreProvider_1 = require("./LwtStoreProvider");
const useLwtStore = () => {
    const [state, dispatch] = (0, use_context_with_error_handler_1.default)(LwtStoreProvider_1.LwtStoreContext, 'LwtStoreProvider');
    return [state, dispatch];
};
exports.useLwtStore = useLwtStore;
